<div class="link-account-modal">
  <h2 mat-dialog-title class="sdf-text-600 sdf-font-bold">
    {{ 'LinkAccount.Title' | translate }}
  </h2>

  <mat-dialog-content class="sdf-text-body-medium">
    <div class="announcement-content">
      <p>{{ 'LinkAccount.Description' | translate }}</p>

      <div class="announcement-details">
        <div class="account-columns">
          <div class="account-column">
            <p class="account-label">{{ 'LinkAccount.PrimaryAccount' | translate }}</p>
            <p class="account-label">
              @if (data.primaryAccount.type === 'Apple') {
                <fa-icon [icon]="faApple"></fa-icon>
              } @else if (data.primaryAccount.type === 'Google') {
                <fa-icon [icon]="faGoogle"></fa-icon>
              } @else {
                <fa-icon [icon]="faKey"></fa-icon>
              }
              ({{ data.primaryAccount.type }})</p>
            <div class="account-info">
              @if (data.primaryAccount.picture) {
                <img
                  class="account-picture"
                  [src]="data.primaryAccount.picture"
                  [alt]="data.primaryAccount.name"
                  />
              }
              <div class="account-text">
                <p class="account-email">{{ data.primaryAccount.name }}</p>
                <p class="account-email">{{ data.primaryAccount.email }}</p>
              </div>
            </div>
          </div>
          <div class="account-column">
            <p class="account-label">{{ 'LinkAccount.SecondaryAccount' | translate }}</p>
            <p class="account-label">
              @if (data.secondaryAccount.type === 'Apple') {
                <fa-icon [icon]="faApple"></fa-icon>
              } @else if (data.secondaryAccount.type === 'Google') {
                <fa-icon [icon]="faGoogle"></fa-icon>
              } @else {
                <fa-icon [icon]="faKey"></fa-icon>
              }
              ({{ data.secondaryAccount.type }})</p>
            <div class="account-info">
              @if (data.secondaryAccount.picture) {
                <img
                  class="account-picture"
                  [src]="data.secondaryAccount.picture"
                  [alt]="data.secondaryAccount.name"
                  />
              }
              <div class="account-text">
                <p class="account-email">{{ data.secondaryAccount.name }}</p>
                <p class="account-email">{{ data.secondaryAccount.email }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (data.organizations.length > 0) {
        <p>{{ 'LinkAccount.OrganizationLabel' | translate }}</p>
        <ul>
          <li *ngFor="let org of data.organizations">{{ org.name }}</li>
        </ul>
      }
      </div>
  </mat-dialog-content>

  <mat-dialog-actions class="actions-wrapper" align="end">
    <button
      class="sdf-btn sdf-btn--lg sdf-btn--alternative" [mat-dialog-close]="false">
      <fa-icon [icon]="faThumbsDown"></fa-icon>
      {{ 'LinkAccount.RejectButton' | translate }}
    </button>
    <button
      class="sdf-btn sdf-btn--lg sdf-btn--primary" [mat-dialog-close]="true">
      <fa-icon [icon]="faThumbsUp"></fa-icon>
      {{ 'LinkAccount.ConfirmButton' | translate }}
    </button>
  </mat-dialog-actions>
</div>


